<template>
  <div class="faq-accordion">
    <div 
      v-for="(faq, index) in faqs" 
      :key="index"
      class="faq-item"
      :class="customClass"
      :style="getAnimationStyle(index)"
    >
      <div 
        class="faq-question"
        @click="toggleFaq(index)"
        :class="{ active: faq.isOpen }"
      >
        <div class="faq-question-content">
          <span class="faq-number" v-if="showNumbers">{{ index + 1 }}.</span>
          <span class="faq-question-text">{{ faq.question }}</span>
        </div>
        <i 
          class="fas fa-chevron-up faq-arrow"
          :class="{ rotated: faq.isOpen }"
        ></i>
      </div>
      <transition name="slide-fade">
        <div v-show="faq.isOpen" class="faq-answer">
          <p>{{ faq.answer }}</p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "FAQAccordion",
  props: {
    faqs: {
      type: Array,
      required: true,
      default: () => []
    },
    showNumbers: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: "animate-on-scroll fade-in-up"
    }
  },
  methods: {
    toggleFaq(index) {
      this.$emit('toggle', index);
      // Actualizar el estado local si es necesario
      if (this.faqs[index]) {
        this.faqs[index].isOpen = !this.faqs[index].isOpen;
      }
    },
    getAnimationStyle(index) {
      return { 'animation-delay': `${index * 0.1}s` };
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.faq-accordion {
  .faq-item {
    margin-bottom: 1.5rem;
    background: white;
    border: 2px solid $landing-border-light;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
    
    &:hover {
      border-color: $landing-primary-color;
      box-shadow: 0 5px 15px rgba(40, 167, 69, 0.15);
    }
  
    .faq-question {
      padding: 1.5rem 2rem;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.3s ease;
      background: white;
      
      &:hover {
        background: #F8F9FA;
      }
      
      &.active {
        background: linear-gradient(135deg, #F8F9FA 0%, #E8F4F8 100%);
        border-bottom: 2px solid #E5EAEE;
      }
      
      .faq-question-content {
        display: flex;
        align-items: center;
        gap: 15px;
        flex: 1;
        
        .faq-number {
          font-size: 1.3rem;
          font-weight: 700;
          color: $landing-primary-color;
          min-width: 30px;
        }
        
        .faq-question-text {
          font-size: 1.5rem;
          font-weight: 600;
          color: #2D4A4D;
          line-height: 1.5;
        }
      }
      
      .faq-arrow {
        color: $landing-primary-color;
        font-size: 1.2rem;
        transition: transform 0.3s ease;
        
        &.rotated {
          transform: rotate(180deg);
        }
      }
    }
    
    .faq-answer {
      padding: 0 2rem 1.5rem 2rem;
      background: white;
      
      p {
        font-size: 1.3rem;
        color: #5A6D70;
        line-height: 1.8;
        font-weight: 400;
        margin: 0;
        padding-left: 45px;
      }
    }
  }
}

// Transición para el acordeón
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

@media (max-width: 768px) {
  .faq-accordion .faq-item {
    .faq-question {
      padding: 1.25rem 1.5rem;
      
      .faq-question-content .faq-question-text {
        font-size: 1.05rem;
      }
    }
    
    .faq-answer p {
      font-size: 1rem;
      padding-left: 35px;
    }
  }
}
</style>
